import { variablesGlobales } from "../configs/variables";


const baseUrl = variablesGlobales.urlServiceBackend;
const baseUrlImports = variablesGlobales.urlServiceImports;

export const CREATE_REFERRALS = baseUrl + "/api/v1/referrals/create";
export const GET_MY_REFERRALS = baseUrl + "/api/v1/referrals/getByIdParent";
export const GET_MY_REWARDS = baseUrl + "/api/v1/rewardsHistory/findByUser/";
export const SUBSCRIBE_USER_WEB_PUSH = baseUrl + "/api/v1/webPush/subscribe";
export const GET_RATES_CURRENT_INTEREST= baseUrl + "/api/v1/interesCorriente/findAll";
export const UPDATE_RATES_CURRENT_INTEREST= baseUrl + "/api/v1/interesCorriente/update";
export const GET_LATE_PAYMENT_INTEREST= baseUrl + "/api/v1/interesMoratorio/findAll";
export const UPDATE_LATE_PAYMENT_INTEREST= baseUrl + "/api/v1/interesMoratorio/update";
export const CREATE_LATE_PAYMENT_INTEREST= baseUrl + "/api/v1/interesMoratorio/create";
export const VALIDATE_HAS_VIGENT_CREDIT= baseUrl + "/api/v1/credits/hasActive";
export const REQUEST_PROCESS_PHYSICAL_SIGNATURE= baseUrl + "/api/v1/physicalSignature/request";
export const UPDATE_QUOTA_STATUS= baseUrl + "/api/v1/quotaStatus/update";
export const INCREMENT_QUOTA_FROM_REWARD_SELECTED = baseUrl + "/api/v1/quotaStatus/incrementQuotaFromRewardSelected";
export const UPDATE_CREDIT_USER = baseUrl + "/api/v1/credits/update/";
export const UPDATE_REWARD_HISTORY = baseUrl + "/api/v1/rewardsHistory/update/";
export const GET_REWARDS = baseUrl + "/api/v1/reward/findAll";
export const GET_AVAILABLE_REWARD = baseUrl + "/api/v1/rewardsHistory/validateAvailableRewards/";
export const ADD_PRINCIPAL_BANK_ACCOUNT = baseUrl + "/api/v1/info/addPrincipalBankAccount";
export const CHANGE_PRINCIPAL_BANK_ACCOUNT = baseUrl + "/api/v1/info/changePrincipalBankAccount";
export const DELETE_BANK_ACCOUNT = baseUrl + "/api/v1/info/deleteAccount";
export const GET_SETTING_BY_NAME = baseUrl + "/api/v1/settings/getBySettingName";
export const UPDATE_BASIC_INFO = baseUrl + "/api/v1/info/updateBasicInfo/";
export const CREATE_VERIFY_ACCOUNT = baseUrl + "/api/v1/verifyAccounts/create";
export const UPDATE_BANK_ACCOUNT = baseUrl + "/api/v1/info/updateAccountById";
export const GET_INFO_DISBURSEMENT = baseUrl + "/api/v1/disbursement/getInfoDisbursement/";


//backoffice
export const GET_DATA_BY_GENERATE_PAYMENT_LINK = baseUrl + "/api/v1/credits/getDataByGeneratePaymentLink";
export const REPORT_UTM_LEADS = baseUrlImports + "/api/v1/utm-leads/report";
export const GET_PARTNERS = baseUrlImports + "/api/v1/utm-leads/partners";
export const GENERATE_PAGARE = baseUrlImports + "/api/v1/utils/generate/pagare";